import React from 'react'
import './about.css'

import me from '../../assets/me-about.jpeg'

import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'
import Github from './Github'

function About() {
  const cards = [
    {
      title: 'Experience',
      subtitle: '3+ Years working',
      icon: <FaAward className='about__icon' />,
    },
    {
      title: 'Clients',
      subtitle: '100+ clients worldwide',
      icon: <FiUsers className='about__icon' />,
    },
    {
      title: 'Projects',
      subtitle: '30+ completed projects',
      icon: <VscFolderLibrary className='about__icon' />,
    },
  ]
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <img src={me} className='about__me-image' alt='' />
        </div>
        <div className='about__content'>
          <div className='about__cards'>
            {cards.map((card, i) => (
              <AboutCard {...card} key={i + 1} />
            ))}
          </div>
          <p>
            Hello there, I am Mahadi Abuhuraira a computer science student at
            A.B.U, Nigeria. My inquisitive nature and the never-ending thirst
            for challenges drive me into programming among many other things.
            <br />
            I am a creative, analytical and result-driven person with an
            affinity to team work. I'm also a fast learner who never stops
            learning and always open to exploring new ideas.
            <br />
            When I'm not coding, I enjoy reading Qur'an, playng games and
            watching movies.
          </p>

          <a href='#contact' className='btn btn-primary'>
            Let's Talk
          </a>
        </div>
      </div>
      {/* <Github /> */}
    </section>
  )
}

const AboutCard = ({ title, subtitle, icon }) => {
  return (
    <article className='about__card'>
      {icon}
      <h5>{title}</h5>
      <small>{subtitle}</small>
    </article>
  )
}
export default About
